export const MIN_SCALE = 0.05;
export const MAX_SCALE = 1;

export const FIT_TO_SCREEN_BUTTON_DATA_TEST_ID = 'fit-to-screen-button';
